import { SpinnerCircle, SpinnerSvg, SpinnerWrap } from './styles';
import { SpinProps } from './types';

export const Spin = ({ size = 40, color = 'var(--color-primary)', ...other }: SpinProps) => (
    <SpinnerWrap size={size} {...other}>
        <SpinnerSvg size={size} viewBox="0 0 40 40">
            <SpinnerCircle color={color} />
        </SpinnerSvg>
    </SpinnerWrap>
);

Spin.displayName = 'Spin';
